import axios from "axios";

const ENV_BASE = process.env.REACT_APP_BACKEND_URL;
const bare = (h) => h.replace(/^www\./, "");
// Serve API from the same origin when visiting the www / non-www twin of the backend host (avoids cross-origin blocks)
const sameSite = (() => {
  try {
    return ENV_BASE && bare(new URL(ENV_BASE).hostname) === bare(window.location.hostname);
  } catch {
    return false;
  }
})();
const BASE = sameSite ? window.location.origin : ENV_BASE;

export const api = axios.create({ baseURL: BASE ? `${BASE}/api` : "/api", withCredentials: true });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return d?.msg || String(d);
};

export const PLATFORMS = {
  pc: { label: "PC", long: "PC" },
  ps: { label: "PS", long: "PlayStation" },
};

export const LAUNCHERS = { steam: "Steam", epic: "Epic Games", rockstar: "Rockstar" };

export const money = (n) => `$${Number(n ?? 0).toFixed(2)}`;

export const orderRef = (id) => `OGM-${String(id ?? "").slice(-8).toUpperCase()}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
